/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateStatusRequestBody,
  CreateStatusResponse,
  GetStatusResponse,
  GetStatusesParams,
  GetStatusesResponse,
  UpdateStatusRequestBody,
  UpdateStatusResponse
} from '../model';

import postStatusMutator from '../../../mutators/datastore-instance';
import getStatusesMutator from '../../../mutators/datastore-instance';
import getStatusMutator from '../../../mutators/datastore-instance';
import putStatusMutator from '../../../mutators/datastore-instance';
import deleteStatusMutator from '../../../mutators/datastore-instance';



  /**
 * Statusを新規作成する
 * @summary Statusの新規作成
 */
export const postStatus = (
    createStatusRequestBody?: CreateStatusRequestBody,
 ) => {
      return postStatusMutator<CreateStatusResponse>(
      {url: `/statuses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStatusRequestBody
    },
      );
    }
  /**
 * Statusの一覧・検索をする
 * @summary Statusの一覧・検索
 */
export const getStatuses = (
    params?: GetStatusesParams,
 ) => {
      return getStatusesMutator<GetStatusesResponse>(
      {url: `/statuses`, method: 'GET',
        params
    },
      );
    }
  /**
 * Statusの詳細を取得する
 * @summary statusの詳細取得
 */
export const getStatus = (
    statusId: number,
 ) => {
      return getStatusMutator<GetStatusResponse>(
      {url: `/statuses/${statusId}`, method: 'GET'
    },
      );
    }
  /**
 * Statusを更新する
 * @summary statusの更新
 */
export const putStatus = (
    statusId: number,
    updateStatusRequestBody?: UpdateStatusRequestBody,
 ) => {
      return putStatusMutator<UpdateStatusResponse>(
      {url: `/statuses/${statusId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStatusRequestBody
    },
      );
    }
  /**
 * Status を削除する
 * @summary status の削除
 */
export const deleteStatus = (
    statusId: number,
 ) => {
      return deleteStatusMutator<void>(
      {url: `/statuses/${statusId}`, method: 'DELETE'
    },
      );
    }
  export type PostStatusResult = NonNullable<Awaited<ReturnType<typeof postStatus>>>
export type GetStatusesResult = NonNullable<Awaited<ReturnType<typeof getStatuses>>>
export type GetStatusResult = NonNullable<Awaited<ReturnType<typeof getStatus>>>
export type PutStatusResult = NonNullable<Awaited<ReturnType<typeof putStatus>>>
export type DeleteStatusResult = NonNullable<Awaited<ReturnType<typeof deleteStatus>>>
